<template>
  <div class="dropzone-controls" v-show="items.length > 0">
    <div class="row">
      <div class="small-4 columns padding-R">
        <a class="button cta small block warning" href="javascript:;" @click="clearMap">CLEAR MAP</a>
      </div>
      <div class="small-4 columns padding-L padding-R">
        <a class="button cta small block" href="javascript:;" @click="optimizeRoute">OPTIMIZE ROUTE</a>
      </div>
      <div class="small-4 columns padding-L">
        <a class="button cta small block success" href="javascript:;" @click="savePackage">SAVE PACKAGE</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dropzone-controls',
  computed: {
    items () { return this.$store.state.routing.dropzone.items }
  },
  methods: {
    removeDuplicates (items) {
      return items.filter((item, index, self) => {
        return index === self.findIndex(p => (
          p.reservationID === item.reservationID && p.reservationID === item.reservationID
        ))
      })
    },
    clearMap () { this.$store.commit('routing/clearDropzone') },
    optimizeRoute () {
      let self = this
      let items = self.removeDuplicates(self.items)
      let rsvpIDs = Array.from(items, item => item.reservationID)

      self.$store.commit('routing/setCheckRouteLoading', true)
      self.$sdk.post('/admin/package/optimize', {
        token: self.$store.state.session.sessionToken,
        resIDs: rsvpIDs
      }, r => {
          console.log('J', r)
          self.$store.commit('routing/setCheckRouteLoading', false)
          if (r.error) {
            console.log(r)
            // SHOW error message
            return
          }

          let stops = []
          for (let i = 0; i < r.stops.length; i++) {
            let stop = r.stops[i]
            let isPickup = stop.pickup === 1
            let rsvp = self.items.filter(item =>
              item.reservationID === parseInt(stop.reservationID) &&
              item.isPickup === isPickup)[0]

            stops.push({
              eta: stop.eta,
              maxDuration: stop.maxDuration,
              originalBTT: rsvp.originalBTT,
              inOrder: stop.inOrder,
              isPickup: isPickup,
              location: rsvp.location,
              luggage: rsvp.luggage,
              passengers: rsvp.passengers,
              reservationID: rsvp.reservationID,
              pickupTime: rsvp.pickupTime,
              originalPickupTime: rsvp.originalPickupTime,
              packageID: rsvp.packageID,
              status: rsvp.status
            })
          }
          self.$store.commit('routing/setDropzoneItems', stops)
       })
    },
    savePackage () {
      let self = this
      self.$store.commit('routing/showRoutingModal')

      let message = 'Are you sure you want to save this package?'
      let action = 'SAVE_PACKAGE'
      if (self.$store.state.routing.dropzone.drivers.length === 1) {
        let driver = self.$store.state.routing.dropzone.drivers[0].driver
        message = 'Do you want to keep the assignment of this package to ' +
                  '<a href="/#/provider/' + driver.ID + '" target="_blank">' +
                  driver.firstName + ' ' + driver.lastName +
                  '</a>?'
        action = 'SAVE_PACKAGE_KEEP_DRIVER'
      }
      if (self.$store.state.routing.dropzone.drivers.length > 1) {
        message = 'Please select one driver to assign the package to:'
        action = 'SAVE_PACKAGE_MULTIPLE_DRIVERS'
      }
      self.$store.commit('routing/setConfirmationModal', {
        show: true,
        title: 'Confirm Package',
        message: message,
        action: action
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dropzone-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid rgba(0,0,0,0.3);
  padding: 15px 10px;
}

.row{ padding: 0 10px; }
.padding-L { padding-left: 5px; }
.padding-R { padding-right: 5px; }

.button{
  line-height: 135%;
}

@media screen and (max-width: 430px) {
  .dropzone-controls {
    bottom: 50px;
    padding: 10px 0;
    .button.small {
      font-size: 12px;
      padding: 10px 7px 10px;
    }
  }

  .dispatch-home {
    .dropzone-controls {
      bottom: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Routing/DropzoneControls.vue